// PT-PT formatting helpers
export function formatEUR(v) {
  if (v == null || isNaN(v)) return "0,00 €";
  return new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" }).format(v);
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric" })
      .format(new Date(iso));
  } catch { return "—"; }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("pt-PT", {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit"
    }).format(new Date(iso));
  } catch { return "—"; }
}

// Status label mapping (pt-PT)
export const QUOTE_STATUS_PT = {
  new: "Novo pedido", in_review: "Em análise", waiting_files: "Aguarda ficheiros",
  waiting_customer: "Aguarda cliente", technical_analysis: "Análise técnica",
  in_pricing: "Em cálculo", proposal_preparing: "Preparação de proposta",
  proposal_sent: "Proposta enviada", waiting_approval: "Aguarda aprovação",
  approved: "Aprovado", rejected: "Rejeitado", expired: "Expirado",
  converted_project: "Convertido em projeto", converted_order: "Convertido em encomenda",
  cancelled: "Cancelado",
};

export const PROPOSAL_STATUS_PT = {
  draft: "Rascunho", sent: "Enviada", accepted: "Aceite", rejected: "Rejeitada",
  changes_requested: "Alterações pedidas", expired: "Expirada",
};

export const ORDER_STATUS_PT = {
  new: "Nova encomenda", waiting_validation: "Aguarda validação",
  waiting_payment: "Aguarda pagamento", payment_reported: "Pagamento comunicado",
  in_preparation: "Em preparação", in_production: "Em produção",
  ready_to_ship: "Pronta para envio", shipped: "Expedida",
  delivered: "Entregue", completed: "Concluída", suspended: "Suspensa",
  cancelled: "Cancelada", refunded: "Reembolsada",
};

export const PAYMENT_STATUS_PT = {
  waiting: "Aguarda pagamento", reported: "Pagamento comunicado",
  verifying: "Em verificação", paid: "Pago", rejected: "Rejeitado",
  refunded: "Reembolsado",
};

export const LINE_STATUS_PT = {
  waiting_planning: "Aguarda planeamento", in_queue: "Na fila",
  in_printing: "Em impressão", printing_paused: "Impressão pausada",
  printing_done: "Impressão concluída", quality_check: "Controlo qualidade",
  reprint: "Reimpressão necessária", in_finishing: "Em acabamento",
  in_assembly: "Em montagem", in_packaging: "Em embalamento",
  ready_shipping: "Pronto expedição", shipped: "Expedido",
  problem: "Problema", completed: "Concluído",
};

export const JOB_STATUS_PT = {
  queued: "Na fila", printing: "Em impressão", paused: "Pausado",
  completed: "Concluído", failed: "Falhou", cancelled: "Cancelado",
};

export const REQUEST_TYPE_PT = {
  print_file: "Ficheiro pronto para imprimir",
  modify_file: "Alterar ficheiro existente",
  new_model: "Criar modelo 3D",
  reverse_eng: "Reproduzir peça física",
  idea: "Ideia — precisa de desenvolvimento",
  series: "Pequena série",
  customize: "Personalizar produto",
  other: "Outro",
};

export function statusColor(status) {
  const map = {
    new: "bg-blue-100 text-blue-700",
    in_review: "bg-blue-100 text-blue-700",
    waiting_files: "bg-amber-100 text-amber-700",
    waiting_customer: "bg-amber-100 text-amber-700",
    technical_analysis: "bg-indigo-100 text-indigo-700",
    in_pricing: "bg-indigo-100 text-indigo-700",
    proposal_preparing: "bg-purple-100 text-purple-700",
    proposal_sent: "bg-purple-100 text-purple-700",
    waiting_approval: "bg-amber-100 text-amber-700",
    approved: "bg-emerald-100 text-emerald-700",
    rejected: "bg-rose-100 text-rose-700",
    expired: "bg-zinc-100 text-zinc-700",
    converted_project: "bg-emerald-100 text-emerald-700",
    converted_order: "bg-emerald-100 text-emerald-700",
    cancelled: "bg-zinc-100 text-zinc-700",

    draft: "bg-zinc-100 text-zinc-700", sent: "bg-blue-100 text-blue-700",
    accepted: "bg-emerald-100 text-emerald-700",
    changes_requested: "bg-amber-100 text-amber-700",

    waiting_payment: "bg-amber-100 text-amber-700",
    payment_reported: "bg-blue-100 text-blue-700",
    in_preparation: "bg-indigo-100 text-indigo-700",
    in_production: "bg-indigo-100 text-indigo-700",
    ready_to_ship: "bg-emerald-100 text-emerald-700",
    shipped: "bg-cyan-100 text-cyan-700",
    delivered: "bg-emerald-100 text-emerald-700",
    completed: "bg-emerald-100 text-emerald-700",
    suspended: "bg-amber-100 text-amber-700",
    refunded: "bg-zinc-100 text-zinc-700",

    waiting: "bg-amber-100 text-amber-700",
    reported: "bg-blue-100 text-blue-700",
    verifying: "bg-blue-100 text-blue-700",
    paid: "bg-emerald-100 text-emerald-700",

    queued: "bg-zinc-100 text-zinc-700",
    printing: "bg-indigo-100 text-indigo-700",
    paused: "bg-amber-100 text-amber-700",
    failed: "bg-rose-100 text-rose-700",

    waiting_planning: "bg-zinc-100 text-zinc-700",
    in_queue: "bg-zinc-100 text-zinc-700",
    in_printing: "bg-indigo-100 text-indigo-700",
    printing_paused: "bg-amber-100 text-amber-700",
    printing_done: "bg-emerald-100 text-emerald-700",
    quality_check: "bg-blue-100 text-blue-700",
    reprint: "bg-rose-100 text-rose-700",
    in_finishing: "bg-purple-100 text-purple-700",
    in_assembly: "bg-purple-100 text-purple-700",
    in_packaging: "bg-cyan-100 text-cyan-700",
    ready_shipping: "bg-emerald-100 text-emerald-700",
    problem: "bg-rose-100 text-rose-700",
  };
  return map[status] || "bg-zinc-100 text-zinc-700";
}
